export const getGoldToSpawn = maxGold => Math.round(
  (Math.random() + Math.random() + Math.random()) / 3 * maxGold);
